import React from "react";
import Editor from "react-simple-wysiwyg";
import styles from "./NewEditor.module.css";

function NewEditor({ blogHtml, onBlogChange }) {
  return (
    <div className={styles.editorContainer}>
      <h2 className={styles.editorHeader}>Edit Your Blog</h2>
      <Editor
        value={blogHtml}
        onChange={onBlogChange}
        // toolbarStyle={{
        //   backgroundColor: "#1e40af",
        //   color: "#fff",
        //   padding: "0.75rem",
        //   borderRadius: "5px 5px 0 0",
        // }}
        textareaStyle={{
          minHeight: "400px",
          fontFamily: "Arial, sans-serif",
          fontSize: "1rem",
          color: "#4b5563",
          border: "1px solid #e5e7eb",
          padding: "1rem",
          borderRadius: "5px",
          backgroundColor: "#fff",
        }}
      />
    </div>
  );
}

export default NewEditor;
